import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCross = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 19,
	height: 18,
	viewBox: "0 0 19 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M15.0798 4.8075L14.0223 3.75L9.82983 7.9425L5.63733 3.75L4.57983 4.8075L8.77233 9L4.57983 13.1925L5.63733 14.25L9.82983 10.0575L14.0223 14.25L15.0798 13.1925L10.8873 9L15.0798 4.8075Z",
		fill: "#D52835"
	})
});
export default SvgCross;
